import React, { Fragment, useState, useEffect } from "react";
import {
  Menu,
  Badge,
  Avatar,
  Space,
  Dropdown,
  Tabs,
  List,
  Table,
  Button,
  Input,
  Modal,
  Card,
  Form,
  Row,
  Col,
  Typography,
  message,
  Spin,
  notification,
  Divider,
  Drawer 
} from "antd";
import {
  MenuFoldOutlined,
  UserOutlined,
  LogoutOutlined,
  MenuUnfoldOutlined,
  UnlockOutlined,
  NotificationOutlined,
  BellOutlined,
  FileTextOutlined
} from "@ant-design/icons";
import "./Navbar.less";
import { Link } from "react-router-dom";
import moment from "moment";
import Axios from "axios";
import { url } from "../config/global";
import { render } from "less";
const { TabPane } = Tabs;
const { Title } = Typography;
const data = [
  {
    title: "Ant Design Title 1",
  },
  {
    title: "Ant Design Title 2",
  },
  {
    title: "Ant Design Title 3",
  },
];

function Navbar(props) {
  const [visible, setVisible] = useState(false);
  const [search, setSearch] = useState(false);
  const [notification, setNotification] = useState([]);
  const [dataNotif, setdataNotif] = useState([]);
  const [notifLoader, setNotifLoader] = useState(false);
  const [dataNotifTotal, setdataNotifTotal] = useState([]);
  const [countNotif, setcountNotif] = useState(0);
  const [pagesize, setPagesize] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [loading, setSetLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [showModalNotifikasi, setShowModalNotifikasi] = useState(false);
  const [form, setForm] = useState({
    old_password: "",
    new_password: "",
    confirm_new_password: "",
  });
  const [formError, setFormError] = useState({});
  const handleNotification = () => {
    setVisible(!visible);
  };
  const showDrawer = () => {
    setOpenDrawer(true);
    getNotif(true);
  };

  const onClose = () => {
    setOpenDrawer(false);
  };

  const handleSeeMore = () => {
    setVisible(false);
  };

  useEffect(() => {
    getNotif()
  }, []);

  const openNotification = async (id_notif) => {
      let fd = new FormData();
  
      fd.set("id", id_notif);
     await Axios.post(`${url}/notification/open`, fd, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      })
        .then((res) => {
         
          return true
        })
        .catch((err) => {
          return false
        });
  }
  const handleNotify = (msg) => {
    // Check if the browser supports notifications
    if (!("Notification" in window)) {
      alert("This browser does not support desktop notification.");
      return;
    }

    // Request notification permission from the user
    if (Notification.permission === "granted") {
      // Permission already granted
      new Notification("Notifikasi", {
        body: msg,
        // icon: "/static/media/pt-sankei-dharma-indonesia.da5ad4c0.jpg", // Optional icon for notification
      });
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          new Notification("Notifikasi", {
            body: msg,
            // icon: "/static/media/pt-sankei-dharma-indonesia.da5ad4c0.jpg", // Optional icon for notification
          });
        }
      });
    }
  };
  const handleLogout = () => {
    let fd = new FormData();
    fd.set("id_user", sessionStorage.getItem("id_user"));
    Axios.post(`${url}/logout`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        console.log("Logout");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("id_user");
        sessionStorage.removeItem("parent_item");
        sessionStorage.removeItem("shift_code");
        sessionStorage.removeItem("dn_no");
        sessionStorage.clear();
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
        }
      });
    return props.history.push("/login");
  };

  const handleToggleSearch = (value = false) => {
    console.log(value);
    setSearch(value);
  };

  const redirectMenu = (url,id) => {
    const urlPath = window.location.pathname;
   
    if(openNotification(id))
    {
      if(urlPath != '/scan-outgoing-supplier')
        {
          props.history.push(url);
        } else{
          window.location = url;
        }
    }
    
    

  }
  const onSaveData = () => {
    let fd = new FormData();

    fd.set("new_password", form.new_password);
    fd.set("old_password", form.old_password);

    Axios.post(`${url}/change-password`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        message.success(res.data.message);
        setShowModal(!showModal);
        setForm({
          old_password: "",
          new_password: "",
          confirm_new_password: "",
        });
        // props.history.push("/master-user-internal");
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          setShowModal(!showModal);
          setForm({
            old_password: "",
            new_password: "",
            confirm_new_password: "",
          });
        }
      });
  };
  const showModalNotif = () => {
    getNotifFull();
    setShowModalNotifikasi(true);
  }
  const getNotif =  async (read) => {
    let fd = new FormData();

    fd.set("type", null);
    if (read == true) {
      setNotifLoader(true);
      setcountNotif(0);
      fd.set("isread", true);
    }
    fd.set("np", sessionStorage.getItem('np'));
   await Axios.post(`${url}/notification/polling`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        // console.log('notif',res.data.data.length)
        setNotification(res.data.data);
        res.data.data_toast.map(item => {
          if(item.type == "BACKUP")
          {
            // console.log('BACKUP',true)
            sessionStorage.setItem('backup_status',false)
          }
          handleNotify(item.message)
        })
        if (read != true) {
          setcountNotif(res.data.count_read);
          
          setTimeout(() => {
            getNotif()
          }, 12000);
        } else{
          setNotifLoader(false);
        }
      })
      .catch((err) => {

      });
  };
  const getNotifFull = async (page = 1,field = 'date_time',order='DESC') => {
    setSetLoading(true)
    let fd = new FormData();

    // fd.set("type", "BEFORE-PAINTING");
    fd.set("np", sessionStorage.getItem('np'));
    fd.set("sort", field);
    fd.set("order", order);
    fd.set("page", page);
    fd.set("perpage", pagesize);
    await Axios.post(`${url}/notification/list`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        // console.log('notif',res.data.data.length)
        setdataNotif(res.data.data);
        setdataNotifTotal(res.data.total);
        setSetLoading(false)
      })
      .catch((err) => {
        setSetLoading(false)
      });
  };
  const columns = [

    {
      title: "Pesan",
      dataIndex: "message",
      sorter: true,
      render: (id, record) => (
        <Fragment>
          <span><a onClick={() => redirectMenu(record.url,record._id)}>{record.message}</a></span>
        </Fragment>

      )

    },
    {
      title: "Waktu",
      dataIndex: "date_time",
      sorter: true,
    },
  ];
  const handleTableChange = (pagination, filters, sorter) => {
    setPagesize(pagination.pageSize)
    
    getNotifFull(pagination.current,sorter.field,sorter.order)
  
  };
  return (
    <div className="navbar">
     
      <Modal
        width={600}
        title="Change Password"
        visible={showModal}
        footer={null}
        onCancel={() => setShowModal(!showModal)}
      >
        <Card className="body-data">
          <Form layout="vertical" onFinish={onSaveData}>
            <Row gutter={[30, 30]}>
              <Col xs={24} md={24} lg={24}>
                <Form.Item
                  required
                  name="old_password"
                  label="Kata Sandi Lama"
                  rules={[
                    {
                      required: true,
                      message: "Kata Sandi Lama harus diisi",
                    },
                  ]}
                >
                  <Input
                    type="password"
                    value={form.old_password}
                    onChange={(e) =>
                      setForm({ ...form, old_password: e.target.value })
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={24} lg={24}>
                <Form.Item
                  required
                  label="Kata Sandi Baru"
                  name="new_password"
                  help={formError.new_password}
                  rules={[
                    {
                      required: true,
                      message: "Kata Sandi Baru harus diisi",
                    },
                    {
                      min: 8,
                      message: "Kata Sandi minimal 8 karakter",
                    },
                  ]}
                >
                  <Input
                    type="password"
                    value={form.new_password}
                    onChange={(e) => {
                      setForm({ ...form, new_password: e.target.value });
                      console.log(formError);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={24} lg={24}>
                <Form.Item
                  required
                  label="Ulangi Kata Sandi Baru"
                  name="confirm_new_password"
                  dependencies={["new_password"]}
                  rules={[
                    {
                      required: true,
                      message: "Ulangi Kata Sandi Baru harus diisi",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("new_password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          "Kata Sandi Baru dan Ulangi Kata Sandi Baru harus sama"
                        );
                      },
                    }),
                  ]}
                >
                  <Input
                    type="password"
                    value={form.confirm_new_password}
                    onChange={(e) =>
                      setForm({ ...form, confirm_new_password: e.target.value })
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row justify="start">
              <Col>
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    disabled={
                      !!formError.old_password ||
                      !!formError.new_password ||
                      !!formError.confirm_new_password
                    }
                  >
                    Ubah Kata Sandi
                  </Button>
                  <Button type="default" htmlType="button">
                    Batal
                  </Button>
                </Space>
              </Col>
            </Row>
          </Form>
        </Card>
      </Modal>
      <Modal
        width={800}
        title="Semua Notifikasi"
        visible={showModalNotifikasi}
        footer={null}
        onCancel={() => setShowModalNotifikasi(!showModalNotifikasi)}
      >

        <Row>
          <Col xs={24} md={24} lg={24}>
            <Table
              // scroll={{ x: 1100 }}
              columns={columns}
              dataSource={dataNotif}
              rowKey={(data) => data._id}
              onChange={handleTableChange}
              pagination={{
                pageSize: pagesize,
                total: dataNotifTotal,
                showSizeChanger: true,
              }}
              loading={loading}
            />
          </Col>
        </Row>

        <Row justify="start">
          <Col>
            <Space>

              <Button type="default" htmlType="button" onClick={() => setShowModalNotifikasi(false)}>
                Tutup
              </Button>
            </Space>
          </Col>
        </Row>

      </Modal>
      <div>
        {props.collapsed ? (
          <MenuUnfoldOutlined onClick={props.onToggleCollapsed} />
        ) : (
          <MenuFoldOutlined onClick={props.onToggleCollapsed} />
        )}
      </div>
      {/* <div>
                {moment(new Date()).format('DD MMMM YYYY')}                
            </div> */}
      <div>
        <Menu mode="horizontal" className="menu-header">
          <Menu.Item key="Notification">
            <Dropdown
              overlay={
                <Menu key={"notif"}>

                  <span style={{ marginLeft: '12px', fontSize: '20px' }}>Notifikasi</span>



                  <Divider style={{ marginBottom: '6px', marginTop: '0px' }} />
                  { notifLoader ? (<Menu.Item key="23432" style={{ marginBottom: '2px' }} >
                        <Row>
                          
                          <Col xs={22} md={22} lg={22}>
                          
                            <Row>
                              <Col xs={24} md={24} lg={24}>
                                <span >
                                <Spin >
                                  &nbsp;
                                {/* Loading... */}
                                </Spin>
                                </span>
                              </Col>
                            </Row>
                           
                          </Col>
                        </Row>
                      </Menu.Item>):notification.length == 0 ? (<Menu.Item key="23432" style={{ marginBottom: '2px' }} >
                        <Row>
                          
                          <Col xs={22} md={22} lg={22}>
                          
                            <Row>
                              <Col xs={24} md={24} lg={24}>
                                <span >
                               Semuanya sudah dibaca
                                </span>
                              </Col>
                            </Row>
                           
                          </Col>
                        </Row>
                      </Menu.Item>):null

                  }
                  
                  {
                    notification.map((item, index) => {
                      return (<Menu.Item key={'menunotif'+index}  style={{ marginBottom: '2px' }} onClick={() => {redirectMenu(item.url,item._id);}}>
                        <Row>
                          <Col xs={2} md={2} lg={2}>
                          {!item.is_read ? (<Badge count="New">

                            <FileTextOutlined style={{ fontSize: '40px' }} />
                            </Badge>)
                          :
                          (

                            <FileTextOutlined style={{ fontSize: '40px' }} />
                          )}
                          
                          </Col>
                          <Col xs={22} md={22} lg={22}>
                            <Row>
                              <Col xs={24} md={24} lg={24}>
                                <span >
                                  
                                  {item.message}

                                </span>
                              </Col>
                              <Col xs={24} md={24} lg={24}>
                                <small >
                                  {item.date_time}
                                </small>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Menu.Item>)
                    })
                  }


                  <Divider style={{ marginBottom: '-2px', marginTop: '0px' }} />
                  <Menu.Item key="3" onClick={() => showModalNotif()}>
                    <span >

                      Semua Notifikasi
                    </span>
                  </Menu.Item>
                </Menu>
              }
              trigger={["click"]}
            >
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <Space>
                  <Badge onClick={() => getNotif(true)} size="small" count={countNotif < 10 ? countNotif : '10+'}>
                    <BellOutlined />
                  </Badge>
                </Space>
              </a>
            </Dropdown>
          </Menu.Item>
          <Menu.Item key="profile">
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item key="3">
                    <span onClick={() => setShowModal(!showModal)}>
                      <UnlockOutlined />
                      Change Password
                    </span>
                  </Menu.Item>
                  <Menu.Item key="3">
                    <span onClick={handleLogout}>
                      <LogoutOutlined />
                      Logout
                    </span>
                  </Menu.Item>
                </Menu>
              }
              trigger={["click"]}
            >
              <a
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
              >
                <Space>
                  {sessionStorage.getItem("avatar") ? (
                    <Avatar
                      size="small"
                      src={sessionStorage.getItem("avatar")}
                    />
                  ) : (
                    <Avatar size="small" icon={<UserOutlined />} />
                  )}
                  {!props.screens.xs && (
                    <span> {sessionStorage.getItem("fullname")} </span>
                  )}
                </Space>
              </a>
            </Dropdown>
          </Menu.Item>
        </Menu>
      </div>
      {/* <Drawer
        title="Basic Drawer"
        closable={{ 'aria-label': 'Close Button' }}
        onClose={onClose}
        visible={true}
        size="large"
        width={"600px"}
      >
        <p>Some contents...Some contents...Some contents...Some contents...Some contents...</p>
        <p>Some contents...</p>
        <p>Some contents...</p>
      </Drawer> */}
    </div>
  );
}

export default Navbar;
